import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var birthdayIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.634 7.193c.397 0 .72.324.72.722V9.89h4.985v.016c2.038.084 3.675 1.775 3.675 3.859 0 1.232-.583 2.32-1.472 3.03v4.065c0 1.313-1.01 2.382-2.252 2.382H5.643c-1.241 0-2.25-1.069-2.25-2.382v-4.065a3.873 3.873 0 0 1-1.473-3.03c0-2.084 1.637-3.775 3.675-3.859V9.89h4.985V7.91c0-.395.321-.717.717-.717Zm2.444 9.124c-.673.826-1.771 1.322-3.111 1.322-1.365 0-2.47-.47-3.144-1.267-.659.798-1.737 1.267-3.073 1.267a3.76 3.76 0 0 1-.918-.125v3.345c0 .52.364.942.811.942H18.29c.449 0 .812-.423.812-.942v-3.345c-.295.074-.6.125-.917.125-1.334 0-2.434-.497-3.107-1.322Zm3.107-4.988H5.75c-1.318 0-2.39 1.092-2.39 2.435s1.072 2.45 2.39 2.435c2.06-.023 3.096-2.635 3.096-2.635l.016.04c.138.333 1.177 2.668 3.105 2.595 1.762-.067 2.784-1.956 3.04-2.494l.048-.105.016-.037c.078.18 1.096 2.468 2.902 2.627l.212.009c1.318-.008 2.39-1.092 2.39-2.435s-1.072-2.435-2.39-2.435ZM10.317 3.99c-.078.5.037 1.014.319 1.418a1.7 1.7 0 0 0 1.056.707c.907.176 1.77-.48 1.926-1.465.12-.736-.25-1.297-.608-1.843-.308-.467-.623-.946-.657-1.57a.297.297 0 0 0-.188-.259.256.256 0 0 0-.295.074c-.055.069-1.347 1.666-1.553 2.938",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { birthdayIcon as default };
//# sourceMappingURL=birthdayIcon.js.map
